import { Platform, StyleSheet } from "react-native";
const styles = StyleSheet.create({
  Title: {
    fontSize: 35,
    fontWeight: "bold",
    textAlign: "center",
    color: "#fff",
    marginTop: 30,
  },

  container: {
    flex: 1,
    zoom: 0.75,
    backgroundColor: "#0F0F0F",
  },

  menu: {
    alingnItens: "center",
    height: 975,
    width: 300,
    borderTopRightRadius: 70,
    borderBottomRightRadius: 70,
    borderColor: "#000",
    borderStyle: "solid",
    borderWidth: 2,
    borderLeftColor: "#000",
  },

  header: {
    height: 115,
    backgroundColor: "#FFFFFF15",
  },

  titleMenu: {
    fontSize: 35,
    fontWeight: "bold",
    color: "#fff",
    marginTop: 10,
    marginBottom: 25,
    marginLeft: 25,
  },

  buttomMenu: {
    alignItems: "left",
    alignContent: "center",
    position: "absolute",
    marginTop: 30,
    marginLeft: 40,
  },

  MenuModulos: {
    fontSize: 25,
    textAlign: "center",
    color: "#000",
    marginTop: 25,
  },

  input: {
    borderWidth: 0,
    borderRadius: 15,
    padding: 15,
    backgroundColor: "#FFF",
    width: 505,
    height: 60,
    margin: 20,
    fontSize: 17
  },

  shadowProp: {
    shadowColor: "#C9C9C9",
    shadowOffset: { width: -12, height: 12 },
    shadowOpacity: 0.7,
    shadowRadius: 9,
  },

  Nome: {
    backgroundColor: "#FAEDB5",
    width: 400,
    height: 60,
    margin: 8,
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
  },

  Email: {
    backgroundColor: "#FAEDB5",
    width: 450,
    height: 60,
    margin: 8,
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
  },

  Grupo_Diplo: {
    backgroundColor: "#FAEDB5",
    width: 150,
    height: 60,
    margin: 8,
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
  },

  Alinhador: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },

  Item_Nome: {
    backgroundColor: "#EDEDF4",
    width: 400,
    height: 60,
    margin: 8,
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
  },

  Item_Email: {
    backgroundColor: "#EDEDF4",
    width: 450,
    height: 60,
    margin: 8,
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
  },

  Item_Grupo_Diplo: {
    backgroundColor: "#EDEDF4",
    width: 150,
    height: 60,
    margin: 8,
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
  },

  textTabela: {
    color: "#000",
    textAlign: "center",
    fontSize: 20,
    fontWeight: "bold",
  },

  ButtomCadastrar: {
    width: 300,
    height: 60,
    marginTop: 40,
    backgroundColor: "#E95964",
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
  },

  textButtomCadastar: {
    color: "#FFF",
    textAlign: "center",
    fontSize: 20,
    fontWeight: "bold",
  },
});

export default styles;
